import * as angular from 'angular';
import { NavigationItemsLoaderService } from './navigation-items-loader-service';
import { mxShellNavItemDirective } from './components/mx-shell-nav-item/mx-shell-nav-item';
import { mxShellNavigationPanelComponent } from './components/mx-shell-navigation-panel/mx-shell-navigation-panel';
import { NavigationManager } from './mx-shell-nav-manager';
import { MxNavigationProviderService } from './mx-navigation-provider-service';
import { MxNavigationService } from './mx-navigation-service';
import { mxShellNavTabsLevelComponent } from './components/mx-shell-nav-tabs-level/mx-shell-nav-tabs-level';
import { mxShellNavDropdownLevelComponent } from './components/mx-shell-nav-dropdown-level/mx-shell-nav-dropdown-level';
import { NavigationItem } from './model/navigation-item';
import { StructuresService } from './structures.service';

export const mxNavigationModule = angular
	.module('mx.sb.Navigation', [])
	.directive('mxShellNavItem', mxShellNavItemDirective)
	.component('mxShellNavigationPanel', mxShellNavigationPanelComponent)
	.component('mxShellNavTabsLevel', mxShellNavTabsLevelComponent)
	.component('mxShellNavDropdownLevel', mxShellNavDropdownLevelComponent)
	.service('mx.shell.NavigationItemsLoaderService', NavigationItemsLoaderService)
	.service('mx.shell.NavigationManager', NavigationManager)
	.service('mx.shell.NavigationProviderService', MxNavigationProviderService)
	.service('mx.shell.NavigationService', MxNavigationService)
	.service('mx.shell.StructuresService', StructuresService)
	.value('mx.shell.NavigationItem', NavigationItem);
